import { GMetrixCheckInput } from 'components/GMetrixCheckInput/GMetrixCheckInput';
import { GMetrixTableColumnProps } from 'components/GMetrixTable/components';
import { useCollections } from 'pages/partners/pages/collections/context';
import { GMetrixTable } from 'components/GMetrixTable/GMetrixTable';
import { GMetrixInput } from 'components/GMetrixInput/GMetrixInput';
import { CollectionLoginUser } from 'apis/CollectionApi';
import { FormattedMessage, useIntl } from 'react-intl';
import { Col, Row } from 'react-bootstrap';

type CollectionDetailsStepProps = {
    name: string;
    createLogin: boolean;
    description: string;
    email: string;
    existingLoginUsers?: CollectionLoginUser[];
    firstName: string;
    hasLogin?: boolean;
    isEditMode?: boolean;
    lastName: string;
    onCreateLoginChange?: (value: boolean) => void;
    onDescriptionChange: (value: string) => void;
    onEmailChange?: (value: string) => void;
    onFirstNameChange?: (value: string) => void;
    onLastNameChange?: (value: string) => void;
    onNameChange: (value: string) => void;
};

export const CollectionDetailsStep = (props: CollectionDetailsStepProps) => {

    const {
        name,
        createLogin,
        description,
        email,
        existingLoginUsers = [],
        firstName,
        hasLogin = false,
        isEditMode = false,
        lastName,
        onCreateLoginChange = Function(),
        onDescriptionChange = Function(),
        onEmailChange = Function(),
        onFirstNameChange = Function(),
        onLastNameChange = Function(),
        onNameChange = Function()
    } = props;

    const { showLoginFields } = useCollections();
    const { formatMessage } = useIntl();

    type LoginUserRow = CollectionLoginUser & { Id: number };

    const loginUserRows: LoginUserRow[] = existingLoginUsers.map((user, i) => ({ ...user, Id: i }));

    const loginUserColumns: GMetrixTableColumnProps<LoginUserRow>[] = [
        { field: 'Username', title: formatMessage({ id: 'username.dceab582', defaultMessage: 'Username' }) },
        { field: 'FirstName', title: formatMessage({ id: 'first_name.759a675b', defaultMessage: 'First Name' }) },
        { field: 'LastName', title: formatMessage({ id: 'last_name.029e7273', defaultMessage: 'Last Name' }) }
    ];

    return (
        <div>
            <h5 className="text-strong mb-3">
                <FormattedMessage defaultMessage="Basic Information" id="basic_information.aa3a7eac" />
            </h5>
            <p>
                <FormattedMessage
                    defaultMessage="This page can be used to create an Association of testing centers used for reporting.  <br></br> An Association will allow you to create a report on the entire Association in the same way that you create reports for individual testing centers."
                    id="this_page_can_be_used_to_create_an_assoc.903e7bab"
                    values={{ br: () => <br /> }}
                />
            </p>

            {isEditMode && (
                <div className="d-flex mb-3">
                    <span className="fw-bold me-2">
                        <FormattedMessage defaultMessage="Login Available" id="login_available.46f60134" />
                    </span>
                    <span>
                        {hasLogin ? <FormattedMessage defaultMessage="Yes" description="Formulario" id="yes.104886cd" /> : <FormattedMessage defaultMessage="No" description="Formulario" id="no.4dd074da" />}
                    </span>
                </div>
            )}

            <Row>
                <Col className="mb-3" md={6} sm={12}>
                    <GMetrixInput
                        required
                        label={formatMessage({ id: 'association_name.b1c7b49c', defaultMessage: 'Association Name' })}
                        onChange={e => onNameChange(e.target.value)}
                        value={name}
                    />
                </Col>
            </Row>

            <Row>
                <Col className="mb-3" md={6} sm={12}>
                    <GMetrixInput
                        as="textarea"
                        label={formatMessage({ id: 'description.e1c24171', defaultMessage: 'Description', description: 'Formulario' })}
                        onChange={e => onDescriptionChange(e.target.value)}
                        rows={3}
                        value={description}
                    />
                </Col>
            </Row>

            {isEditMode && existingLoginUsers.length > 0 && (
                <div className="mb-3">
                    <h6 className="fw-bold">
                        <FormattedMessage defaultMessage="Existing Users" id="existing_users.7d6c56cd" />
                    </h6>
                    <GMetrixTable
                        columnData={loginUserColumns}
                        rowData={loginUserRows}
                        tableName={formatMessage({ id: 'existingloginusers.0d8a8937', defaultMessage: 'ExistingLoginUsers' })}
                    />
                </div>
            )}

            {showLoginFields && !isEditMode && (
                <div className="mb-3">
                    <GMetrixCheckInput
                        checked={createLogin}
                        label={formatMessage({ id: 'create_a_login_for_this_association.5b707d2b', defaultMessage: 'Create a Login for this Association?' })}
                        onChange={e => onCreateLoginChange(e.target.checked)}
                        type="checkbox"
                    />

                    {createLogin && (
                        <div className="mt-3">
                            <Row>
                                <Col className="mb-3" md={6} sm={12}>
                                    <GMetrixInput
                                        required
                                        label={formatMessage({ id: 'email.5cbb5845', defaultMessage: 'Email', description: 'Formulario' })}
                                        onChange={e => onEmailChange(e.target.value)}
                                        value={email}
                                    />
                                </Col>
                            </Row>
                            <Row>
                                <Col className="mb-3" md={6} sm={12}>
                                    <GMetrixInput
                                        required
                                        label={formatMessage({ id: 'first_name.c39590d7', defaultMessage: 'First Name:', description: 'New' })}
                                        onChange={e => onFirstNameChange(e.target.value)}
                                        value={firstName}
                                    />
                                </Col>
                            </Row>
                            <Row>
                                <Col className="mb-3" md={6} sm={12}>
                                    <GMetrixInput
                                        required
                                        label={formatMessage({ id: 'last_name.029e7273', defaultMessage: 'Last Name' })}
                                        onChange={e => onLastNameChange(e.target.value)}
                                        value={lastName}
                                    />
                                </Col>
                            </Row>
                        </div>
                    )}
                </div>
            )}
        </div>
    );

};
